import React from 'react';
import AuditLogs from '../components/management/AuditLogs';

const AuditLogsPage = () => {
    return (
        <div className="audit-logs-page">
            <AuditLogs />
        </div>
    );
};

export default AuditLogsPage;
